import { useEffect, useState } from 'react'

// Only the primary pointer decides this. navigator.maxTouchPoints merely says a
// digitizer exists — Windows machines with a touch monitor, a pen tablet or a
// leftover HID touch driver report it while the user drives a mouse, and that
// flipped the whole desktop into touch mode (no draggable, no dragstart).
export const detectTouchEnvironment = () => {
  if (
    typeof window === 'undefined' ||
    typeof window.matchMedia !== 'function'
  ) {
    return false
  }

  return (
    window.matchMedia('(hover: none)').matches ||
    window.matchMedia('(pointer: coarse)').matches
  )
}

export const useTouchEnvironment = () => {
  const [isTouchEnvironment, setIsTouchEnvironment] = useState(() =>
    detectTouchEnvironment()
  )

  useEffect(() => {
    if (
      typeof window === 'undefined' ||
      typeof window.matchMedia !== 'function'
    ) {
      return
    }

    const queries = [
      window.matchMedia('(hover: none)'),
      window.matchMedia('(pointer: coarse)')
    ]

    const updateEnvironment = () => {
      setIsTouchEnvironment(detectTouchEnvironment())
    }

    const cleanups = queries.map(query => {
      query.addEventListener('change', updateEnvironment)
      return () => query.removeEventListener('change', updateEnvironment)
    })

    updateEnvironment()

    return () => {
      cleanups.forEach(cleanup => cleanup())
    }
  }, [])

  return isTouchEnvironment
}
